"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import UserPageHeaderEditBanner from "./UserPageHeaderEditBanner";
export default function UserPageHeaderBanner(t0) {
  const $ = _c(15);
  const {
    profile,
    defaultBanner1,
    defaultBanner2,
    canEdit
  } = t0;
  const [isEditOpen, setIsEditOpen] = useState(false);
  const t1 = `linear-gradient(45deg, ${profile?.banner1 ?? defaultBanner1} 0%, ${profile?.banner2 ?? defaultBanner2} 100%)`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      background: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== canEdit) {
    t3 = canEdit && <div className=""><button onClick={() => setIsEditOpen(true)} className="tw-w-full tw-h-full tw-bg-transparent tw-border-none tw-p-0" aria-label="Edit banner image"><div className="edit-profile tw-absolute tw-inset-0 tw-bg-black/30"><div className="tw-absolute tw-bottom-4 tw-right-4"><PencilIcon /></div></div></button></div>;
    $[2] = canEdit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== defaultBanner1 || $[5] !== defaultBanner2 || $[6] !== isEditOpen || $[7] !== profile) {
    t4 = isEditOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageHeaderEditBanner profile={profile} defaultBanner1={defaultBanner1} defaultBanner2={defaultBanner2} onClose={() => setIsEditOpen(false)} /></CommonAnimationOpacity>;
    $[4] = defaultBanner1;
    $[5] = defaultBanner2;
    $[6] = isEditOpen;
    $[7] = profile;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <CommonAnimationWrapper mode="sync" initial={true}>{t4}</CommonAnimationWrapper>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className="tw-h-24 sm:tw-h-36 tw-group tw-relative tw-overflow-hidden" style={t2}>{t3}{t5}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}